import axios from 'axios';
import { addChannelSprite, state } from '@/shared/components/player/store';
import { ProductType } from '@/shared/enums';

export default {
  data() {
    return {
      sprites: null,
      info: this.$services.resolve('info'),
      lastPreviewTimeRounded: 0,
      fetchErrorsInARow: 0,
      previewDay: null,
    };
  },
  computed: {
    previewUrl() {
      return this.product.previewUrl;
    },
    isBeforeHead() {
      return this.hoverTimeFromProgramStart < state.head;
    },
    isLiveSprite() {
      return this.sprites && this.isBeforeHead;
    },
    jsonIntervalSec() {
      return this.info.thumbnailerInfo.livePreviewIntervalSeconds;
    },
    liveDelay() {
      return this.info.platformSettings.liveDelay || 50;
    },
    isCatchup() {
      return this.product.type === ProductType.PROGRAMME;
    },
    product() {
      return state.product;
    },
  },
  methods: {
    getChannelSprite() {
      const jsonIntervalSec = this.jsonIntervalSec;
      const hoverTimeSec = this.hoverTimeFromUnixZeroSec;

      const playerHeadSec = Date.now() / 1000 - this.liveDelay;
      const previewTimeRounded = Math.ceil(hoverTimeSec / jsonIntervalSec) * jsonIntervalSec;
      if (previewTimeRounded > playerHeadSec || previewTimeRounded === this.lastPreviewTimeRounded) {
        return;
      }
      this.lastPreviewTimeRounded = previewTimeRounded;
      const previewTimeMs = previewTimeRounded * 1000;

      const secondsInDay = 60 * 60 * 24;
      this.previewDay = Math.floor(previewTimeRounded / secondsInDay);

      if (state.channelSprites[previewTimeMs]) {
        this.sprites = state.channelSprites[previewTimeMs];
      } else {
        if (this.fetchErrorsInARow > 3) {
          return;
        }
        axios.get(`${this.previewUrl}/${this.previewDay}/preview_${previewTimeMs}.json`)
          .then(({ data }) => {
            this.sprites = data.sprites;
            addChannelSprite({ [previewTimeMs]: data.sprites });
            this.fetchErrorsInARow = 0;
          })
          .catch(() => {
            this.fetchErrorsInARow += 1;
          });
      }
    },
  },
};
